import React, { Component } from "react"
import { connect } from "react-redux"
import { AppState } from "src/store"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import mutator from "src/utilities/mutator"
import RoleAssignmentHeader from "./RoleAssignmentHeader/RoleAssignmentHeader"
import RoleAssignmentAllRoles from "./RoleAssignmentContent/RoleAssignmentAllRoles/RoleAssignmentAllRoles"
import roleAssignmentHelper from "./Utils/RoleAssignmentHelper"
import RoleTemplateTypes from "../../Types/RoleTemplateTypes"
import PortalUserRoleTypes from "../../Types/PortalUserRoleTypes"
import RoleAssignmentSplash from "./RoleAssignmentSplash/RoleAssignmentSplash"
import { shouldAllowAccess } from "src/utilities/helper"
import "./RoleAssignment.css"
interface Props {
    targetedUserId: string | number
    loggedInUserId: number
    user: any
}

interface State {
    roles: PortalUserRoleTypes[]
    templates: RoleTemplateTypes[]
    templateDex: number
    allChecked: boolean
    busy: boolean
    splash: boolean
}

class RoleAssignment extends Component<Props, State> {

    preRender: { key: string, value: any }[] = []

    state = {
        roles: [],
        templates: [],
        templateDex: -1,
        allChecked: false,
        busy: true,
        splash: true
    }

    componentDidMount(): void {
        this.getAllRoles()
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    /* A function that takes a string and two arguments. It then calls a function with the name of the
    string and passes the two arguments. */
    callFunction = (functionToCall: string, arg1: any, arg2: any) => {
        //@ts-ignore
        this[functionToCall](arg1, arg2)
    }

    getAllRoles = () => {
        if (!this.state.busy) {
            this.manageState([{ key: "busy", value: true }])
        }
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/GetPortalRolesAndAssignments`, AxiosConfig.configValue())
            .then(res => {
                let response = res.data.Data
                //@ts-ignore
                this.getTargetedUserRoles(response.map(item => item.Role))
            })
            .catch(err => {
                this.manageState([{ key: "busy", value: false }])
            })
    }

    getTargetedUserRoles = (allRoles: PortalUserRoleTypes[]) => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/rolesDetailed/${this.props.targetedUserId}`, AxiosConfig.configValue())
            .then(res => {
                roleAssignmentHelper.buildHashTable(res.data.roles, allRoles)
                this.preRender.push({ key: "roles", value: allRoles })
                this.getRoleTemplates()
            })
            .catch(err => {
                this.manageState([{ key: "busy", value: false }])
            })
    }

    getRoleTemplates = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/roleTemplates`, AxiosConfig.configValue())
            .then(res => {
                this.preRender.push({ key: "templates", value: res.data.Data }, { key: "busy", value: false }, { key: "splash", value: false })
                this.manageState(this.preRender)
            })
            .catch(err => {
                this.manageState([{ key: "busy", value: false }])
            })
    }

    updateRoles = () => {
        this.manageState([{ key: "busy", value: true }])
        const rb = roleAssignmentHelper.saveSetup(this.props.targetedUserId, this.props.loggedInUserId)
        // console.log("updateRoles", rb)
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/rolesMultiple`, rb, AxiosConfig.configValue("min"))
            .then(res => {
                // console.log("updateRoles res", res.data)
                this.getAllRoles()
            })
            .catch(err => {
                this.manageState([{ key: "busy", value: false }])
            })
    }

    render() {

        const { roles, templates, templateDex, allChecked, busy, splash } = this.state
        const {targetedUserId, loggedInUserId} = this.props

        //@ts-ignore
        const readOnly = (parseInt(targetedUserId) === loggedInUserId) && !shouldAllowAccess("PortalAdmin")

        // console.log(roleAssignmentHelper.getStorage())
        // console.log("RoleAssignment state", this.state)

        return (
            <div className={`RoleAssignment RoleAssignment${splash ? "Splash" : "NoSplash"}`}>

                {splash && <RoleAssignmentSplash />}
                {!splash &&
                    <>
                        <RoleAssignmentHeader
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            templates={templates}
                            templateDex={templateDex}
                            busy={busy}
                            readonly={readOnly}
                        />
                        <div className="RoleAssignmentContent">
                            <RoleAssignmentAllRoles
                                manageParentState={this.manageState}
                                roles={roles}
                                allChecked={allChecked}
                                readonly={readOnly}
                            />
                        </div>
                    </>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    loggedInUserId: parseInt(state.user.userId),
    user: state.user
})

export default connect(mapStateToProps)(RoleAssignment)